import { axiosEduServer } from "../utils/configAxios";
import { BASE_URL } from "../utils/configAxios";

export const crearPersona = (data) =>
  axiosEduServer.post("/persona", data).then(({ data }) => data);

export const actualizarPersona = (id, data) =>
  axiosEduServer.put(`/persona/${id}`, data).then(({ data }) => data);

export const eliminarPersona = (id) =>
  axiosEduServer.delete(`/persona/${id}`).then(({ data }) => data);

export const getOnePersona = (id) =>
  axiosEduServer.get(`/persona/${id}`).then(({ data }) => data);

export const getAllPersonas = () =>
  axiosEduServer.get("/persona").then(({ data }) => data);

export const actualizarFotoPerfil = (formData) =>
  axiosEduServer.put(`/persona/actualizar-foto-perfil`, formData);


export const eliminarFotoPerfil = (id) => {
  return axiosEduServer.delete(`/persona/eliminar-imagen/${id}`);
};



// En tu archivo persona.service.js
export const getFotoPerfilURL = (fileName) => {
  if (!fileName) return "https://cdn-icons-png.flaticon.com/512/847/847969.png";
  
  // Elimina 'images/perfil/' si ya está en el filename
  const cleanFileName = fileName.replace('images/perfil/', '');
  
  return `${BASE_URL}/persona/images/perfil/${cleanFileName}?t=${Date.now()}`;
};